import { store } from '../../store/store';
import { actions, behaviorState, handleStateChange, events, updateTranslations, } from './sdk';
import { BehaviorSubject } from 'rxjs';
import { messageHandler } from './message-handler';
import ImportExtensionTranslations from './helpers/importExtensionTranslations';
const extensionsModules = new Map();
export const interpreterUids = [];
export const extensionsSubject = new BehaviorSubject([]);
export const extensionCallMenuItemsSubject = new BehaviorSubject([]);
export const extensionMainMenuItemsSubject = new BehaviorSubject([]);
export const modalSubject = new BehaviorSubject(null);
export const callFrameSubject = new BehaviorSubject(null);
extensionsSubject.subscribe((extensions) => {
    const callMenu = [];
    const mainMenu = [];
    for (const ext of extensions) {
        if (Boolean(ext.extensionCallMenuItems)) {
            callMenu.push(...ext.extensionCallMenuItems.map((item) => ({
                props: item,
                extensionName: ext.name,
            })));
        }
        if (Boolean(ext.extensionMainMenuItems)) {
            mainMenu.push(...ext.extensionMainMenuItems.map((item) => ({
                props: item,
                extensionName: ext.name,
            })));
        }
    }
    extensionCallMenuItemsSubject.next(callMenu);
    extensionMainMenuItemsSubject.next(mainMenu);
});
export const installExtension = async (extensionName, extensionCode) => {
    if (!extensionCode) {
        return;
    }
    const extensionModule = await import(`./extensions/${extensionCode}`);
    const extension = extensionModule.default;
    if (!extension) {
        return;
    }
    extensionsModules.set(extensionName, extension);
    if (Boolean(extension.translations)) {
        updateTranslations(ImportExtensionTranslations(extension.name, extension.translations));
    }
    if (Boolean(extension.install)) {
        extension.install({
            state: behaviorState,
            actions: actions,
            events: events,
        });
    }
    extensionsSubject.next([...extensionsModules.values()]);
};
export const loadAndInstallExtension = async (extensionName, extensionCode) => {
    if (extensionsModules.get(extensionName) ||
        !extensionName ||
        !extensionCode) {
        return;
    }
    extensionsModules[extensionName] = null;
    // Remote-URL extension loading has been removed (SEC-3167). Extensions are
    // loaded from local bundled modules by name only. No registry extension uses
    // a remote URL, so an http(s) extensionCode can only originate from a forged
    // realtime message — refuse it and emit a filterable signal.
    if (extensionCode.startsWith('http')) {
        // console.* is forwarded to Datadog (see utility/datadog-util). Filter on
        // securityEvent:extension_install_blocked. Should never fire legitimately.
        console.error('Blocked remote-URL extension install', {
            securityEvent: 'extension_install_blocked',
            ticket: 'SEC-3167',
            extensionName,
            attemptedSourceCode: extensionCode,
        });
        return;
    }
    await installExtension(extensionName, extensionCode);
};
const uninstallExtensionModule = (extensionName) => {
    const script = document.querySelector(`#ext-module-${extensionName}`);
    if (script) {
        script.remove();
    }
};
const uninstallExtensionStyles = (extensionName) => {
    const link = document.querySelector(`#ext-style-${extensionName}`);
    if (link) {
        link.remove();
    }
};
export const uninstallExtension = (extensionName) => {
    const extension = extensionsModules.get(extensionName);
    if (extension?.uninstall) {
        extension.uninstall();
    }
    uninstallExtensionModule(extensionName);
    uninstallExtensionStyles(extensionName);
    extensionsModules.delete(extensionName);
    extensionsSubject.next([...extensionsModules.values()]);
};
export const resetState = () => {
    extensionsModules.clear();
    extensionsSubject.next([]);
};
export const extensionsStoreWatch = () => {
    // Supplies extensions with updated state
    store.subscribe(handleStateChange);
};
export const messagesStoreWatch = () => {
    store.subscribe(() => {
        void messageHandler();
    });
};
